/**
 * @generated SignedSource<<f8eddb3178c64d62ed2e419c3c2127e0>>
 * @relayHash 179c787963a87f9ac481d69f76ddfbf3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 39a85592f1294c3374f9b1fcdc6603e2b593932a1551171b0140dffc3e31d85f

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PlaybookLogsQuery } from './PlaybookLogsQuery.graphql';

const node: PreloadableConcreteRequest<PlaybookLogsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "39a85592f1294c3374f9b1fcdc6603e2b593932a1551171b0140dffc3e31d85f",
    "metadata": {},
    "name": "PlaybookLogsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
